import Api from './Api'
import {
  AddCommentInterface,
  ConfirmCommentInterface,
} from '../../interfaces/CommentInterface'
import { errorHandler } from '../../utils'

class Comment extends Api {
  readonly urls = {
    all: '/Comment/AllComments',
    add: '/Comment/Add',
    confirm: '/Comment/Confirm/',
    getPharmacyComments: '/Comment/GetCommentOfPharmacy/',
  }

  all = async (skip: number, top: number = 10): Promise<any> => {
    try {
      const result = await this.postJsonData(
        `${this.urls.all}?top=${top}&$skip=${skip * top}&$orderby=id desc`,
      )
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }
  add = async (data: AddCommentInterface): Promise<any> => {
    try {
      const result = await this.postJsonData(this.urls.add, data)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }
  confirm = async (data: ConfirmCommentInterface): Promise<any> => {
    try {
      const url = `${this.urls.confirm}?commentId=${data.commentId}&confirm=${data.confirm}`
      const result = await this.postJsonData(url)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }
  getPharmacyComments = async (
    pharmacyKey: string = '',
    skip: number,
    top: number = 10,
  ): Promise<any> => {
    try {
      const result = await this.postJsonData(
        `${
          this.urls.getPharmacyComments
        }?pharmacyKey=${pharmacyKey}&top=${top}&$skip=${skip * top}`,
      )
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }
}

export default Comment
